import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useGiftSelectionModalControls = () => {
    const { isModalOpen, closeModal, editModal, openModal } = useBrowserModalControls('gift-selection');

    return {
        isGiftSelectionModalOpen: isModalOpen,
        openGiftSelectionModal: () => openModal(),
        closeGiftSelectionModal: closeModal,
        editGiftSelectionModal: editModal,
    };
};
